import { useEffect, useState } from 'react';
import { getCtaLink } from '../utils/bankPageUtils/bankOffers';

function useOfferOrderLink(locale: string, offer, isLoggedIn: boolean) {
  const [link, setLink] = useState('#');

  useEffect(() => {
    getCtaLink(locale, offer, isLoggedIn).then((url) => setLink(url));
  }, [locale, offer, isLoggedIn, setLink]);

  return link;
}

export default useOfferOrderLink;
